
  <div class="container">
    <div class="section-left only-desktop">
      <!--
        <p-carousel transition="fade" [value]="carouselItems" [numVisible]="1" [circular]="true" [showNavigators]="false" [showIndicators]="false" [autoplayInterval]="7000">
          <ng-template pTemplate="item" let-item>
            <div class="container-img fade-image">
              <img [src]="item" alt="Imagen" class="img-carousel">
            </div>
          </ng-template>
        </p-carousel>
      -->

      <div class="carousel-container">
        <div class="carousel">
          <div class="figure-img">
            <img loading="lazy" *ngFor="let image of carouselItems; let i = index"
                [src]="image"
                [class.active]="i === currentImageIndex"
                class="carousel-image">
          </div>
        </div>
      </div>
    </div>
    <div class="section-right">
      <div class="flex justify-content-between align-items-center">

        <div class="container-flex">
          <i class="pi pi-angle-left"></i>
          <a class="link-second" (click)="backTo()">{{'LoginPage.LoginBack' | translate}}</a>
        </div>
        <app-switch-lang></app-switch-lang>
      </div>
      <!--
      <div class="col-12 md:col-8 lg:col-8">
        <div class="grid grid-nogutter surface-section text-800">
          <div class="col-12 md:col-6 p-6 text-center md:text-left flex align-items-center ">
            <section>
              <span class="block text-6xl font-bold mb-1">{{'LoginPage.WelcomeText' | translate}}</span>
              <div class="text-6xl text-primary font-bold mb-3">{{'LoginPage.LegendText' | translate}}</div>
              <p class="mt-0 mb-4 text-700 line-height-3">
                {{'LoginPage.SecondLegendText' | translate}}
              </p>
              <button pButton pRipple label="{{'LoginPage.MarketplaceButton' | translate}}" type="button" class="mr-3 p-button-raised"
                (click)="goToMarketplace()"></button>
              <button pButton pRipple label="{{'LoginPage.CreateAccountButton' | translate}}" type="button" class="p-button-outlined"
                (click)="goToSignupPage()"></button>
            </section>
          </div>
        </div>
      </div>
      -->

      <div class="body-right">
        <div class="card-login-new">
          <div class="container-logo">

            <a [routerLink]="'/'">
              <img src="../../../../assets/img/fruzty-logo-slogan.png" width="200" height="auto" />
            </a>
          </div>
          <div class="card-container">
            <div class="header-card">
              <h1 class="title-form">{{'LoginPage.WelcomeText' | translate}}</h1>
              <h3 class="subtitle-form">{{'LoginPage.LogInText' | translate}}</h3>
            </div>
            <form [formGroup]="formGroup" (ngSubmit)="handleSubmit()">
              <div *ngIf="showLogin" class="p-fluid formgrid grid">
                <div class="field col-12 error-container">
                  <p-message *ngIf="loginError" severity="error" text="{{'LoginPage.LoginErrorMessage' | translate}}"></p-message>
                </div>
                <div class="field col-12">
                  <label class="label-form"  for="email">{{'LoginPage.EmailLabel' | translate}}</label>
                  <input class="input-style" id="email" type="text" pInputText formControlName="email" />
                  <small *ngIf="submit && formGroup.controls['email'].invalid"
                    class="p-error">{{getErrorMessage('email')}}</small>
                </div>
                <div class="field col-12" style="margin-bottom: 30px;">
                  <label class="label-form" for="password">{{'LoginPage.PasswordLabel' | translate}}</label>
                  <p-password id="password" type="password" formControlName="password" [feedback]="false"
                    [toggleMask]="true" class="input-style"/>
                  <small *ngIf="submit && formGroup.controls['password'].invalid"
                    class="p-error">{{getErrorMessage('password')}}</small>
                </div>
                <div class="flex justify-content-end field col-12">
                  <a [routerLink]="resetPasswordRoute" class="font-medium no-underline ml-2 text-right cursor-pointer"
                    style="color: #8c2b87;font-size:.8em; line-height:1.1em">{{'LoginPage.ForgotPasswordText' | translate}} </a>
                </div>
                <div class="col-12">
                  <p-button label="{{'LoginPage.LoginButton' | translate}}" type="submit" [loading]="loading" />
                </div>

                <div class="container-divider">
                  <div class="divider">
                  </div>
                  O
                  <div class="divider">
                  </div>
                </div>
                <div class="col-12">
                  <p-button styleClass="p-button-outlined p-button-secondary" label="{{'LoginPage.RequestCodeText' | translate}}" type="button" (onClick)="visibleDialog = true" ></p-button>
                </div>
              </div>

              <div *ngIf="showAuthentication" class="p-fluid grid flex">
                <div class="col-12 mb-2">
                  <p>{{'LoginPage.VerifiedCodeText' | translate}}</p>
                </div>
                <div class="col-2">
                  <p-inputNumber #authCode1 [min]="0" [max]="9" formControlName="authCode1" [maxlength]="1" [useGrouping]="false"
                    class="p-inputtext-sm" (onInput)="handleFocusNext(authCode2)" (onFocus)="clear('authCode1')" (paste)="onPaste($event)" [style]="{'text-aling':'center'}">
                  </p-inputNumber>
                </div>

                <div class="col-2">
                  <p-inputNumber #authCode2 [min]="0" [max]="9" formControlName="authCode2" [maxlength]="1"
                    class="p-inputtext-sm" (onInput)="handleFocusNext(authCode3)" (onFocus)="clear('authCode2')" (paste)="onPaste($event)"></p-inputNumber>
                </div>

                <div class="col-2">
                  <p-inputNumber #authCode3 [min]="0" [max]="9" formControlName="authCode3" [maxlength]="1"
                    class="p-inputtext-sm" (onInput)="handleFocusNext(authCode4)" (onFocus)="clear('authCode3')" (paste)="onPaste($event)"></p-inputNumber>
                </div>

                <div class="col-2">
                  <p-inputNumber #authCode4 [min]="0" [max]="9" formControlName="authCode4" [maxlength]="1"
                    class="p-inputtext-sm" (onInput)="handleFocusNext(authCode5)" (onFocus)="clear('authCode4')" (paste)="onPaste($event)"></p-inputNumber>
                </div>

                <div class="col-2">
                  <p-inputNumber #authCode5 [min]="0" [max]="9" formControlName="authCode5" [maxlength]="1"
                    class="p-inputtext-sm" (onInput)="handleFocusNext(authCode6)" (onFocus)="clear('authCode5')" (paste)="onPaste($event)"></p-inputNumber>
                </div>

                <div class="col-2">
                  <p-inputNumber #authCode6 [min]="0" [max]="9" formControlName="authCode6" [maxlength]="1"
                    class="p-inputtext-sm" (onFocus)="clear('authCode6')" (paste)="onPaste($event)"></p-inputNumber>
                </div>
                <div class="col-12">
                  <p-message *ngIf="codeError" severity="error" text="Código incorrecto o expirado."></p-message>
                </div>
                <div class="col-6 mt-2">
                  <p-button label="{{'LoginPage.ConfirmCodeButton' | translate}}" type="submit" [loading]="loading"/>
                </div>
                <div class="col-6 mt-2">
                  <p-button  styleClass="p-button-outlined p-button-secondary" label="{{'LoginPage.ResendCodeButton' | translate}}" (onClick)="resendCode()" [loading]="loading" />
                  <!--
                    <button pButton class="ghost-btn" (click)="resendCode()" [loading]="loading">{{'LoginPage.ResendCodeButton' | translate}}</button>
                  -->
                </div>

              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>



<p-dialog class="modal-request-code" [resizable]="false" [modal]="true" [draggable]="false" [(visible)]="visibleDialog" [style]="{width: '30wv'}">
  <app-requests-code></app-requests-code>
</p-dialog>
